import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Tailwind 친화적 className 합치기. clsx 가 조건부/배열/객체를 평탄화한 뒤
 * twMerge 가 충돌하는 utility 를 정리해 *뒤에 들어온 것이 이긴다*.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
